/**
 * DateTime
 * @namespace gplans.utils.services
 */
(function () {
  'use strict';

  angular.
  module('gplans.utils.services').
  factory('DateTime', DateTime);

  function DateTime() {

    var DateTime = {
      now: now,
      setNow: setNow,
      unsetNow: unsetNow,
      parseDate: parseDate,
      dayDiff: dayDiff };


    return DateTime;

    /////////////////////
    var _now = null;

    function now() {
      if (_now)
      return new Date(_now.valueOf());
      return new Date();
    }

    function setNow(newNow) {
      _now = new Date(newNow.valueOf());
    }

    function unsetNow() {
      _now = null;
    }

    function parseDate(str) {
      var dt = new Date(str);
      var d = new Date(dt.getFullYear(), dt.getMonth(), dt.getDate());
      return d;
    }

    function dayDiff(first, second) {
      return Math.round((second - first) / (1000 * 60 * 60 * 24));
    }
  }

})();